<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { _isMobile } from "@/utils/utils";
export default {
  data() {
    return {
      windowWidth: "",
      isMobile: _isMobile(),
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        // 双重保障
        this.$nextTick(() => window.scrollTo(0, 0));
      },
    },
  },
  mounted() {
  },
  beforeDestroy() {

  },
  methods: {

  },
};
</script>
<style lang="less">
@import "@/styles/variables";

#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.scroll-active {
  /* 响应式样式 - 小于1200px时添加滚动条 */
  min-width: 1200px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.f-box {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

/* 定义动画 */
@keyframes bannerFadeInUpTxt {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes bannerFadeInUpImg {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
/* 移动端页面公共样式 */
.mobile-f-ctx-box-comm {
  width: 100%;
  padding-top: 32px;
  box-sizing: border-box;

  img {
    vertical-align: middle;
  }

  .mobile-ctx-box-comm {
    margin: 32px 12px;
    background: #fff;
    border-radius: 4px;
    padding: 24px 12px;
    box-sizing: border-box;
  }
}
</style>
